import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {RollAnimatedBalance} from "../../../../common/RollAnimatedBalance";
import {Messages} from "../../../../Messages";
import {registerStyle, Theme} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {isSafari} from "../../../../Utils";
import {ADD_FUNDS_MINIMISED_HEIGHT} from "../../../WidgetConstants";
import {WidgetRoutes} from "../../../WidgetRoutes";
import {startDashboardFlow} from "../../../../panel/flows/startFlow";


export const minimisedBalanceStyle = {
    fontSize: 14,
    fontWeight: "bold",
    width: "45px !important",
    height: "1em",
    color: () => Theme.props.WALLET_BALANCE_COLOR,
    transform: "translateY(0) !important",
    marginRight: 8,
};

class AddFundsMinimisedStyle extends StyleSheet {
    @styleRule
    addFundsMinimised = {
        bottom: 0,
        zIndex: 1,
        height: ADD_FUNDS_MINIMISED_HEIGHT,
        padding: "12px 24px",
        position: "absolute",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    };

    @styleRule
    addFundsLink = {
        transition: ".2s ease",
        fontSize: 12,
        fontWeight: "400",
        color: this.themeProps.WALLET_ADD_FUNDS_LINK,
        whiteSpace: "nowrap",
        display: "flex",
        ">:last-child": {
            transform: isSafari() ? "translateY(2px)" : "translateY(1px)",
        },
        ":hover>:last-child": {
            color: this.themeProps.WALLET_ADD_FUNDS_LINK_HOVER,
            opacity: 1,
        },
    };

    @styleRule
    blinkButton = {
        color: this.themeProps.WHITE,
        " path ": {
            fillOpacity: 1,
        },
    };

    @styleRule
    balance = {
        ...minimisedBalanceStyle,
        opacity: 0,
    };

    @styleRule
    externalLink = {
        display: "inline-block",
        marginLeft: 6,
    }
}

@registerStyle(AddFundsMinimisedStyle)
export class AddFundsMinimised extends UI.Element {
    static instance;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);

        attr.addClass(this.styleSheet.addFundsMinimised);
    }

    render() {
        const {styleSheet} = this;

        return [
            <Link href={WidgetRoutes.ADD_FUNDS} className={styleSheet.addFundsLink}>
                <RollAnimatedBalance ref="balance" className={styleSheet.balance} />
                <div>{Messages.blinkWallet}</div>
            </Link>,
            <Link className={styleSheet.blinkButton} onClick={() => startDashboardFlow()}>
                {Messages.dashboard}
            </Link>,
        ]
    }

    static getHeight() {
        return this.instance.getHeight();
    }

    onMount() {
        super.onMount();

        this.constructor.instance = this;
    }
}
